import React from 'react';

export default {
  width: 16,
  height: 7,
  content: (
    <path d="M5.333 7h-2C1.493 7 0 5.433 0 3.5S1.492 0 3.333 0h2C5.702 0 6 .313 6 .7c0 .387-.298.7-.667.7h-2c-1.104 0-2 .94-2 2.1 0 1.16.896 2.1 2 2.1h2c.369 0 .667.313.667.7 0 .387-.298.7-.667.7zM12.667 7h-2C10.298 7 10 6.687 10 6.3c0-.387.298-.7.667-.7h2c1.104 0 2-.94 2-2.1 0-1.16-.896-2.1-2-2.1h-2c-.369 0-.667-.313-.667-.7 0-.387.298-.7.667-.7h2C14.507 0 16 1.567 16 3.5S14.508 7 12.667 7z M12 4.2H4c-.368 0-.667-.313-.667-.7 0-.387.299-.7.667-.7h8c.368 0 .667.313.667.7 0 .387-.299.7-.667.7z" />
  )
};
